import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ThemeContext from '../../../../providers/ThemeProvider';

const BookingCalendarButton = ({ className, isActive, onClick, text }) => {
  const theme = useContext(ThemeContext);

  return (
    <>
      <button
        className={classNames(`${className} button`, {
          button__active: isActive,
        })}
        onClick={onClick}
        type="button"
      >
        {text}
      </button>
      <style jsx>{`
        .button {
          background-color: ${theme.colors.primary};
          color: ${theme.colors.textonprimary};
          border: none;
          border-radius: 4px;
          border-bottom: 2px solid ${theme.colors.primarydark};
          font-weight: bold;
          padding: 4px 8px 2px 8px;
          font-size: 12px;
        }
        .package-button {
          border-bottom: 2px solid ${theme.colors.greycharcoal};
          border-radius: 16px;
          font-size: 14px;
          font-weight: 500;
          margin: 0;
          padding: 9px;
          margin: 2px 0;
        }
        .package-button-selected {
          background-color: ${theme.colors.primary};
          border: 1px solid ${theme.colors.primary};
          color: ${theme.colors.textonprimary};
        }
        .package-button-unselected {
          background-color: ${theme.colors.navbackground};
          border: none;
          color: ${theme.commoncolors.greycharcoal};
        }
        .package-button-unselected:hover {
          outline: 1px solid ${theme.commoncolors.greycharcoal};
        }
        .package-nav-button {
          background-color: ${theme.commoncolors.white};
          border-radius: 20px;
          border-width: 0;
          box-shadow: 1px 0px 8px #888888;
          color: ${theme.colors.primary};
          font-size: 13px;
          min-width: 62px;
          padding: 6px 8px 4px 8px;
          width: 100%;
        }
      `}</style>
    </>
  );
};

BookingCalendarButton.propTypes = {
  className: PropTypes.string,
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
  text: PropTypes.string,
};

export default BookingCalendarButton;
